import { render, staticRenderFns } from "./ShopCODCommission.vue?vue&type=template&id=02eab94e&"
import script from "./ShopCODCommission.vue?vue&type=script&lang=js&"
export * from "./ShopCODCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports